import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {TaskModel} from "../../models/task.model";
import {TasksActions, TasksAPiActions, TasksChannelActions} from "../state/tasks.actions";
import {tasksFeature} from "../state/tasks.state";

@Injectable()
export class TasksFacadeService {

  constructor(@Inject(Store) private store: Store<TaskModel>) {
  }

  subscribeToChannels() {
    this.store.dispatch(TasksChannelActions.subscribe());
  }

  unsubscribeFromChannels() {
    this.store.dispatch(TasksChannelActions.unsubscribe());
  }

  removeByIds(ids: string[]) {
    this.store.dispatch(TasksActions.removeTasks({ids: ids}));
  }

  removeAll() {
    this.store.dispatch(TasksActions.removeAll());
  }

  setMany(tasks: TaskModel[]) {
    this.store.dispatch(TasksActions.setTasks({tasks: tasks}));
  }

  getByIds(taskIds: string[]) {
    this.store.dispatch(TasksAPiActions.getTasks({taskIds: taskIds}));
  }

  selectByIds(taskIds: string[]): Observable<TaskModel[]> {
    return this.store.select(tasksFeature.selectTasks(taskIds));
  }

  selectAll(): Observable<TaskModel[]> {
    return this.store.select(tasksFeature.selectAll);
  }

}
